<template>
  <div class="content" ref="content">
    <template v-if="!isWenquan">
      <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">学生问卷测评</h3>
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
          <el-form-item label="完成状态">
            <el-select v-model="formInline.status" clearable filterable placeholder="请选择审批状态">
              <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column prop="name" label="测评名称" width="160">
        </custom-table-column>
        <custom-table-column prop="reply_create_time" label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.reply_create_time" style="color:var(--blue)">已完成</span>
            <span v-else style="color:var(--red)">未完成</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="description" label="描述" min-width="160">
        </custom-table-column>
        <custom-table-column prop="creator" label="创建人" width="100">
        </custom-table-column>
        <custom-table-column prop="create_date" label="创建时间" width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.reply_create_time" @click="handleOper(scope.row)" type="text" size="small">前往测评</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
      <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="operDialogVisible" width="530px">
        <el-form :model="ruleOperForm" ref="ruleOperForm" label-width="100px" class="demo-ruleForm">
          <el-form-item v-if="ruleOperForm.status == 2" label="处理结果" prop="fail_reason" :rules="[{ required:true, message: '请输入处理结果', trigger: 'blur' }]">
            <el-input type="textarea" v-model="ruleOperForm.fail_reason" placeholder="请输入处理结果" style="width:352px;" :rows="5"></el-input>
          </el-form-item>
          <el-form-item v-else label="处理结果" prop="fail_reason">
            <el-input type="textarea" v-model="ruleOperForm.fail_reason" placeholder="请输入处理结果" style="width:352px;" :rows="5"></el-input>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;">
            <el-button type="primary" @click="submitFormByFun('ruleOperForm',setStatus)">确认</el-button>
            <el-button @click="resetForm('ruleOperForm')" style="margin-right:24px;">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
        <span>是否删除</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="deleteMethod">确 定</el-button>
        </span>
      </el-dialog>
    </template>
    <template v-else>
      <el-page-header @back="goBack" class="pageHeader1" :content="titContent">

      </el-page-header>
      <div style="width:100%;">
        <iframe :src="src" width="100%" :height="iframeHeight" frameborder="0" scrolling="no">

        </iframe>
      </div>
    </template>
  </div>
</template>

<script>
import { dcwjUrl } from '@/api';
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      props: {
        label: 'name',
      },
      status: [
        { value: 1, label: '已完成' },
        { value: 2, label: '未完成' },
      ],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      formInline: {
        token: this.$store.state.token,
        status: '',
        api_url_secret: 'cf0b5c23',
      },
      ruleOperForm: {
        id: '',
        status: '',
        fail_reason: '',
      },
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      operDialogVisible: false,
      isWenquan: false,
      titContent: '',
      src: '',
      iframeHeight:0
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.$store.dispatch('getStandards');
    console.log(this.$refs.content.parentElement.parentElement.offsetHeight)

    this.iframeHeight = this.$refs.content.parentElement.parentElement.offsetHeight-172
  },
  methods: {
    handleOper(row) {
      this.isWenquan = true;
      this.titContent = row.name;
      this.src = `${dcwjUrl}/Weixin/in/in?token=userToken:${this.$store.state.token}&questionnaire_id=${row.question_id}`;
    },
    goBack() {
      // history.back();

      // this.$confirm('已填写的内容不会保存, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // })
      //   .then(() => {
          this.isWenquan = false;
          this.titContent = '';
          this.src = '';
          this.$nextTick(()=>{
            this.getList()
          })
        // })
        // .catch(() => {});
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/training/room/apply/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    getOrganList() {
      this.beforeGetOrgan();
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceDcwjServer('questionnaire/lists', 'get', params);
      if (res.code == 20000 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = parseInt(res.data.count);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
.pageHeader1 {
  color: #4578ed;
  letter-spacing: 2px;
  height: 34px;
  margin-bottom: 32px;
  border-bottom: 4px solid #c4d8f1;
  position: relative;
  text-indent: 4px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
// .pageHeader1:before {
//   width: 236px;
// }
</style>
